export default "__VITE_ASSET__5e044220__"